import { BASE_API_URL } from '../constants'
import Token from './Token'

export const PublicPropertyApi = {
    get: (propertyUuid) => {
        return fetch(BASE_API_URL + '/public/properties/' + propertyUuid, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + Token.getToken(),
            },
        }).then((r) => {
            if (r.ok) {
                return r.json()
            } else {
                return []
            }
            throw new Error(r.statusText)
        })
    },
}
